export default {
    bindings: {
        item: '<',
        guests: '=',
        loading: '=',
        valid: '=',
        callback: '&'
    },
    controller: 'addToBasketController',
    template: require('../views/basket.add.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/components/basket.add.component.js